module.exports = "https://coursera_assets.s3.amazonaws.com/images/7ae6fe8c846415de1a72dc6eb4e0b1a2.png";